import { alpha } from '@mui/material';

export const getInternationalCardStyles = (theme, isDark) => ({
  wrapper: {
    position: 'relative',
    display: 'inline-block',
    // Ensure hover pill does not get clipped
    overflow: 'visible',
  },
  // Absolute-positioned pill — appears on desktop hover
  // Mirrors DiscoveryActions.js styling exactly for visual consistency
  actionPill: {
    position: 'absolute',
    bottom: 8,
    right: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 0.4,
    backgroundColor: 'background.paper',
    borderRadius: '20px',
    boxShadow: isDark
      ? '0 3px 10px rgba(0,0,0,0.4)'
      : '0 3px 10px rgba(0,0,0,0.12)',
    padding: '4px 6px',
    zIndex: 10,
    pointerEvents: 'auto',
    transition: 'opacity 0.15s ease-in-out',
    '&:hover': {
      boxShadow: isDark
        ? '0 6px 16px rgba(0,0,0,0.5)'
        : '0 6px 15px rgba(0,0,0,0.18)',
    },
  },
  buyBtn: {
    backgroundColor: 'success.main',
    '&:hover': {
      backgroundColor: 'success.dark',
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
    },
    minWidth: '28px',
    height: '24px',
    fontSize: '0.72rem',
    fontWeight: 700,
    borderRadius: '12px',
    transition: 'all 0.2s ease',
    textTransform: 'none',
    px: 0.8,
    py: 0,
  },
  sellBtn: {
    backgroundColor: 'error.main',
    '&:hover': {
      backgroundColor: 'error.dark',
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
    },
    minWidth: '28px',
    height: '24px',
    fontSize: '0.72rem',
    fontWeight: 700,
    borderRadius: '12px',
    transition: 'all 0.2s ease',
    textTransform: 'none',
    px: 0.8,
    py: 0,
  },
  chartBtn: {
    width: 24,
    height: 24,
    color: 'text.secondary',
    '&:hover': {
      color: 'primary.main',
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
    padding: 0,
  },
});
